import React, { PureComponent } from "react";
import './Menu.css';
import Button from '../Button/Button.js';
import Constants from '../Constants.js';
import PlatformTest from '../PlatformTest.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faApple, faAndroid } from '@fortawesome/free-brands-svg-icons'
library.add(faApple);
library.add(faAndroid);

class Appwall extends PureComponent {
    render() {

        // Default to showing both buttons
        let buttons = <div>
            <a href={Constants.iosDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faApple} />
                    iOS
                </Button>
            </a>
            <a href={Constants.androidDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faAndroid} />
                    Android
                </Button>
            </a>
        </div>
        // If iOS, show only iOS download button
        if (PlatformTest.ios()) {
            buttons = <a href={Constants.iosDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faApple} />
                    Download App
                </Button>
            </a>
        }
        // If Android, show only Android download button
        else if (PlatformTest.android()) {
            buttons = <a href={Constants.androidDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faAndroid} />
                    Download App
                </Button>
            </a>
        }

        return (
            <div
                style={{
                    width: '100%',
                    position: 'relative',
                    paddingBottom: '40px',
                    paddingTop: '40px',
                    borderRadius: '20px',
                }}
            >
                <div
                    style={{
                        width: '80%',
                        position: 'relative',
                        left: '10%',
                        backgroundColor: '#fff',
                    }}
                >
                    <p className="Paragraph">
                        Download the free <span style={{ fontWeight: 'bold' }}>Word Surge</span> app on iOS or Android for hints and {Constants.paidLevels} more levels!
                    </p>
                    {buttons}
                </div>

                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        height: '1px',
                        backgroundColor: 'lightgray',
                        zIndex: '-1',
                    }}
                >
                </div>

            </div>
        );
    }
}

export default Appwall;
